import React from "react";
import { useStaticQuery, graphql } from "gatsby";
import Img from "gatsby-image";
import CardHolder from "../components/CardHolder";
import Layout from "../components/Layout";
import TextWrapper from "../components/TextWrapper";

const IndexPage = () => {
  const homeQuery = useStaticQuery(graphql`
    query homeQuery {
      banner: file(relativePath: { eq: "seaways.banner.jpg" }) {
        id
        childImageSharp {
          fluid(maxWidth: 1332) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      markdown: mdx(frontmatter: { title: { eq: "home" } }) {
        id
        body
      }
      allAirtable(filter: { data: { Ready_to_Publish_: { eq: true } } }) {
        nodes {
          id
          data {
            ID
            Annum
            Caption_for_Website
            Creator
            Image_URL
            Copyright
            Title_of_illustration
            Section
            LinkImageNumber
            Image_File {
              large: localFiles {
                childImageSharp {
                  fixed(width: 230) {
                    ...GatsbyImageSharpFixed
                  }
                }
              }
            }
          }
        }
      }
    }
  `);
  const allTheData = homeQuery.allAirtable.nodes.filter(
    (x) => x.data.Caption_for_Website && x.data.Caption_for_Website.length > 1 // maybe take this out?
  );
  const text = homeQuery.markdown;
  // console.log(allTheData.map((x) => x.data.Annum));
  return (
    <Layout isHome>
      <div style={{ marginBottom: "25px" }}>
        <Img fluid={homeQuery.banner.childImageSharp.fluid} />
      </div>
      {text && text.body ? <TextWrapper>{text.body}</TextWrapper> : null}
      <CardHolder cards={allTheData} />
    </Layout>
  );
};

export default IndexPage;
